export const TEXT = {
    TIMELINE_FEED_HEADER: 'Activity',
    PILL_SWITCH_HEADER: 'feed view'
};